<template>
  <v-container fluid>
    <v-toolbar flat class="pb-10">
      <DebouncedTextField
        class="d-print-none"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
      />
      <v-spacer/>
      <v-btn-toggle
        v-model="search"
      >
        <v-btn
          v-for="team of teamFilter"
          v-bind:key="team"
          :value="`team:${team}`"
        >{{ team }}
        </v-btn>

      </v-btn-toggle>

      <v-spacer/>
      <ShippingGroupSelector
        :dates.sync="dates"
        :shippingGroup.sync="shippingGroup"
      />
    </v-toolbar>

    <!-- packing works per shipping group (local, ship): the task panel carries it in its production slot -->
    <TaskPanel
      show-team-member-buttons
      :show-clear-tasks="showClearTasks"
      v-if="hasShippingGroup"
      :team="team"
      :dates="dates"
      :production="shippingGroup"
      :search="search"
      :filter="filter"
    >
      <template v-slot:task-title="{ props: { task}}">
        <v-card-title>
          {{ task.title }}
          <v-spacer/>
          <v-icon v-if="task.complete">mdi-check</v-icon>
        </v-card-title>
      </template>
    </TaskPanel>
    <v-alert v-if="!hasShippingGroup">
      Please select a shipping group
    </v-alert>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex';
import {dateFormatted, extractFoodId, formatWeight} from '@/store/utils';
import TaskPanel from '@/components/tasks/TaskPanel';
import ShippingGroupSelector from '@/components/ShippingGroupSelector.vue';
import urlState from "@/router/urlState";
import DebouncedTextField from "@/components/DebouncedTextField.vue";

export default {
  name: "PackTasks",
  components: {TaskPanel, ShippingGroupSelector, DebouncedTextField},
  mixins: [urlState],
  mounted() {
    this.syncToUrl({
      param: 'taskFilter', urlParam: 'status', initFromRoute: true,
      // parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'showAllergy', urlParam: 'allergy', initFromRoute: true,
      parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'showGarnish', urlParam: 'garnish', initFromRoute: true,
      parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'onlyGarnish', urlParam: 'garnish_only', initFromRoute: true,
      parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'dates', urlParam: 'dates', initFromRoute: true,
      parseCallback: (v) => Array.isArray(v) ? v : [v]
    });
    this.syncToUrl({
      param: 'shippingGroup', urlParam: 'shippinggroup', initFromRoute: true,
    });
    this.syncToUrl({
      param: 'search', urlParam: 'search', initFromRoute: true,
      // parseCallback: (v) => v === 'true'
    });
  },
  computed: {
    ...mapGetters(['getComponent', 'getMeal',]),
    hasShippingGroup() {
      return this.dates.length > 0 && !!this.shippingGroup;
    },
    filter() {
      return this.showGarnish ? '' : 'garnish';
    }
  },

  methods: {
    extractFoodId,
    getComponents(componentIds) {
      return componentIds.map(this.getComponent).sort((a, b) => a.name.localeCompare(b.name));
    },
    getTimerId(id) {
      return `I${id}`;
    },
    dateFormatted,
    formatTaskAmount(task) {
      console.log('formatTaskAmount', task);

      if (task.source) {
        const {source: {totalAmount, cookedTotal, rawTotal}} = task;
        if (cookedTotal && cookedTotal === rawTotal) {
          return this.formatWeightWithUnits(cookedTotal);
        } else if (cookedTotal) {
          return `${this.formatWeightWithUnits(cookedTotal)} (raw ${this.formatWeightWithUnits(rawTotal)})`;
        } else if (totalAmount) {
          return this.formatWeightWithUnits(totalAmount);
        } else {
          return this.formatWeightWithUnits(0)
        }
      }
    },
    formatWeightWithUnits(amount) {
      const units = ['g', 'kg'];
      const decimalPlaces = [1, 2];
      return formatWeight(amount, units, decimalPlaces);
    },
  },
  data() {
    return {
      dates: [],
      shippingGroup: null,
      search: null,
      teamsSelected: null,
      loading: null,
      showGarnish: null,
      onlyGarnish: null
    }
  },
  watch: {},
  props: {
    team: {type: String, required: true},
    teamFilter: {type: Array, default: null, required: false},
    showClearTasks: {type: Boolean, default: false, required: false}
  }
}
</script>

<style scoped>

</style>
